import * as types from '../mutation-types';

const initialState = {
  sidebarOpened: true,
  mobileSidebarOpened: false,
  mobileProjectInfoOpened: false,
  purchaseSidebarOpened: false,
  toastMsg: null,
  tutorialModalOpened: true,
  projectImagesModalOpen: false,
  mobileRedeemCouponOpened: false,
};

const mutations = {
  [types.TOGGLE_PROJECT_IMAGES_MODAL](state, payload) {
    const newPayload = payload || !state.projectImagesModalOpen;
    state.projectImagesModalOpen = newPayload;
  },
  [types.TOGGLE_SIDEBAR](state, payload) {
    const newPayload = payload || !state.sidebarOpened;
    state.sidebarOpened = newPayload;
  },
  [types.TOGGLE_MOBILE_SIDEBAR](state, payload) {
    state.mobileSidebarOpened = typeof payload === 'boolean' ? payload : !state.mobileSidebarOpened;
  },
  [types.TOGGLE_MOBILE_PROJECT_INFO](state, payload) {
    const newPayload = payload || !state.mobileProjectInfoOpened;
    state.mobileProjectInfoOpened = newPayload;
  },
  [types.SHOW_TOAST](state, payload) {
    state.toastMsg = payload;
  },
  [types.HIDE_TOAST](state) {
    state.toastMsg = null;
  },
  [types.TOGGLE_PURCHASE_SIDEBAR](state, payload) {
    const newPayload = payload || !state.purchaseSidebarOpened;
    state.purchaseSidebarOpened = newPayload;
  },
  [types.TOGGLE_TUTORIAL_MODAL](state, payload) {
    const newPayload = payload || !state.tutorialModalOpened;
    state.tutorialModalOpened = newPayload;
  },
  [types.TOGGLE_MOBILE_COUPON](state, payload) {
    const newPayload = payload.open || !state.mobileRedeemCouponOpened;
    state.mobileRedeemCouponOpened = newPayload;
  },
};

const actions = {
  focusOnProject({ commit }) {
    commit(types.TOGGLE_MOBILE_SIDEBAR, false);
  },
  closeAndSaveTutorialModal({ commit }) {
    if (window.localStorage) {
      window.localStorage.setItem('tutorialModalSeen', true);
    }
    commit(types.TOGGLE_TUTORIAL_MODAL, false);
  },
};

export default {
  state: initialState,
  mutations,
  actions,
};
